//import "babel-polyfill";

import $ from 'jquery';
import Router from './util/router';

// Components
import PageTransitions from './components/SetupPageTransitions.js';
import Animations from './components/SetupAnimations.js';
import FixedHeader from './components/SetupFixedHeader.js';
import ContactOverlay from './components/SetupContactOverlay.js';
import ProjectsFilters from './components/SetupProjectsFilters.js';
import HomeBackgroundScroll from './components/SetupHomeBackgroundScroll.js';
import HashChange from './components/SetupHashChange.js';

// Foundation 6
import 'what-input/dist/what-input.js';
import 'foundation-sites/dist/js/plugins/foundation.core.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.js';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.js';
import 'foundation-sites/dist/js/plugins/foundation.util.timerAndImageLoader.js';
import 'foundation-sites/dist/js/plugins/foundation.util.touch.js';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers.js';

// Init foundation
$(document).foundation();

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Sage = {
  // All pages
  'common': {
    init: function() {
      // JavaScript to be fired on all pages
      PageTransitions();
      Animations();
      FixedHeader();
      ProjectsFilters();
      ContactOverlay();
      $(window).on( 'hashchange', HashChange );
      // trigger event handler to init Isotope
      HashChange();
    },
    finalize: function() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    }
  },
  // Home page
  'home': {
    init: function() {
      // JavaScript to be fired on the home page
      HomeBackgroundScroll();
    },
    finalize: function() {
      // JavaScript to be fired on the home page, after the init JS
    }
  }
};

// Load Events
$(document).ready(function() {
  new Router(Sage).loadEvents();
});



// WEBPACK FOOTER //
// ./scripts/main.js